import React from "react"
import { StyledComponent } from "@rogue_4/types"
import classNames from "classnames"

import styles from "./index.module.less"

const Health: StyledComponent<{
    border?: boolean
    kalts?: boolean
    health: number
}> = ({ className, style, border, health, kalts }) => {
    return (
        <div
            className={classNames(
                styles.health,
                border && styles.border,
                className
            )}
            style={style}
        >
            <div
                className={classNames(
                    kalts && styles.kalts,
                    styles[`health${health}`],
                    styles.line
                )}
            ></div>
        </div>
    )
}

export default Health
